import { FluidSlider } from '../../__utils/sliders';
import GalleryLightbox from '../../__page/lightboxGallery';
import lightboxControlVideo from '../../__videoLigthbox/lightboxControlVideo';
import resetIframeOnSlideChange from '../../__videoLigthbox/resetIframeOnSlideChange';
import '../../__videoLigthbox/loadMoreMediaPosts';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        FluidSlider.init();
        GalleryLightbox.init();
        lightboxControlVideo.bindEvent();
        resetIframeOnSlideChange();
    },
    loaded() {},
    resized() {
        // GalleryLightbox.refreshSlider();
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
